import React, { useEffect } from 'react';

import { BrowserUtils, InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

export const SingleLogoutPage: React.FC = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      const accounts = instance.getAllAccounts();
      instance
        .logoutRedirect({
          account: accounts[0],
          idTokenHint: accounts[0]?.idToken,
          onRedirectNavigate: () => !BrowserUtils.isInIframe(),
        })
        .catch((err) => {
          console.error("MSAL Logout error:", err);
        });
    }
  }, [instance, inProgress]);

  return <div />;
};
